import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  grid: {
    alignContent: "flex-start",
    direction: "row",
    margin: "5%",
  },

  image: {
    width: "20em",
  },

  title: {
    fontSize: "2em",
    color: "#000",
    fontWeight: "800",
    fontFamily: "Inter",
  },

  alertContainer: {
    containerJustify: 'center',
    backgroundColor: "#F4F5F7",
    borderRadius: '8px',
    padding: '2%',
    margin: '5%',
  },

  alertTitle: {
    fontSize: "1em",
    color: "#000",
    fontWeight: "600",
    fontFamily: "Inter",
  },

  alertSubTitle: {
    fontSize: "1em",
    color: "#000",
    fontWeight: "100",
    fontFamily: "Inter",
  },

  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

export { useStyles };
